import BrightCove from '_shared/vendors/brightcove';
define([
  'globals',
  'jquery',
  'helpers',
], function(globals, $, helpers) {

  'use strict';

  const loadDictionaryTermHtml = (href) => {
    var { term } = helpers.getQueryParams(href, 'term');
    var productLineId = globals.productLineId;
    return new Promise((resolve) => {
      $.ajax({
        url: globals.dictionaryTerms.path,
        data: {
          term,
          productLineId: productLineId,
        },
        dataType: 'json',
        success: (data) => {
          resolve(data);
        },
      });
    });
  };

  const loadDictionaryTermData = (href) => {
    return loadDictionaryTermHtml(href).then((data) => {
      const { definition, image, term, video } = data
      return $.when({
        term,
        definition,
        hasImage: !!image,
        imageUrl: image,
        videoTag: video,
      });
    });
  };

  const loadDictionaryTermAndVideoData = (href) => {
    return loadDictionaryTermData(href).then((termData) => {
      // No live clicker video tag for this dictionary term, so no videos to load
      if (!termData.videoTag) return $.when($.extend(termData, { hasVideo: false, videos: [] }));
      // Call out to Brightcove to see if we have a video for this tag
      return new BrightCove().getVideosForProductId(termData.videoTag)
        .then((videoResults) => {
          // Merge the Brightcove video results in to our term data
          return $.when($.extend(termData, { hasVideo: !!videoResults && !!videoResults.length, videos: videoResults }));
        });
    });
  };

  return {
    getTerm: loadDictionaryTermAndVideoData
  };
});
